import React, { useEffect, useState } from 'react';

import { useSiteContext } from '@zooplus/commons-lang';

import { getUrlLocalised, useTranslation } from '../../../hooks/use-translations';
import useMedias from '../../../hooks/useMedias';
import { useMetrics } from '../../../hooks/useMetrics';
import { ContentBannerDetail } from '../../../model/content';
import { ContentService } from '../../../services/ContentService';

import styles from './ContentBanner.module.scss';

const TARGET_IDENTIFIER = 'autoshipment';

export const ContentBanner = () => {
  const { site, locale } = useSiteContext();
  const { isMobile, isSmallMobile, isBigDesktop } = useMedias();
  const { t } = useTranslation();

  const [bannerInfo, setBannerInfo] = useState<ContentBannerDetail | undefined>(undefined);

  const metrics = useMetrics('content-banner');

  useEffect(() => {
    metrics.renderInit();
  }, []);

  useEffect(() => {
    ContentService()
      .getBanner(site.domain, locale, TARGET_IDENTIFIER)
      .then((response) => {
        if (response?.targetLink) {
          setBannerInfo(response);
        }
      })
      .catch(() => {
        metrics.renderError('EndpointError');
      });
  }, []);

  useEffect(() => {
    if (bannerInfo) {
      metrics.renderSuccess();
    }
  }, [bannerInfo]);

  const image =
    bannerInfo?.mobileImage && (isMobile || isSmallMobile) ? (
      <img
        src={bannerInfo.mobileImage}
        alt={bannerInfo.mobileAltText || bannerInfo.desktopAltText || bannerInfo.superWideAltText}
      />
    ) : bannerInfo?.superWideImage && isBigDesktop ? (
      <img
        src={bannerInfo.superWideImage}
        alt={bannerInfo.superWideAltText || bannerInfo.desktopAltText || bannerInfo.mobileAltText}
      />
    ) : bannerInfo?.desktopImage && !(isMobile || isSmallMobile) ? (
      <img
        src={bannerInfo.desktopImage}
        alt={bannerInfo.desktopAltText || bannerInfo.superWideAltText || bannerInfo.mobileAltText}
      />
    ) : undefined;

  return image ? (
    <div className={styles.contentBanner}>
      {bannerInfo?.targetLink ? (
        <a className={styles.link} href={getUrlLocalised(t, `${bannerInfo.targetLink}`)}>
          {image}
        </a>
      ) : (
        image
      )}
    </div>
  ) : (
    <></>
  );
};
